// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — header.styled.classic.js, новая — header.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './header.styled.classic';
import * as cp from './header.styled.cp';

export const Container = isCp ? cp.Container : classic.Container;
export const Content = isCp ? cp.Content : classic.Content;
export const Item = isCp ? cp.Item : classic.Item;
